import React from 'react';
import { LoginForm } from '../components/auth/LoginForm';
import { useLocation } from 'wouter';
import { SEO } from '../components/SEO';

export function LoginPage() {
  const [, setLocation] = useLocation();

  const handleLoginSuccess = () => {
    setLocation('/');
  };

  return (
    <>
      <SEO
        title="Login | btoolme"
        description="Log in to your btoolme account to access your personalized software recommendations."
        path="/login"
        noindex={true}
      />
      <LoginForm onSuccess={handleLoginSuccess} />
    </>
  );
}